import { memo, useState, useEffect } from 'react';

const ClickerGame = memo(() => {
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(15);
  const [targetPos, setTargetPos] = useState({ x: 50, y: 50 });
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!started || timeLeft <= 0) return;
    const t = setTimeout(() => setTimeLeft(tl => tl - 1), 1000);
    return () => clearTimeout(t);
  }, [started, timeLeft]);

  const handleClick = () => {
    if (!started) { setStarted(true); return; }
    if (timeLeft <= 0) return;
    setScore(s => s + 1);
    setTargetPos({ x: 10 + Math.random() * 80, y: 10 + Math.random() * 80 });
  };

  return (
    <div className="text-center">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-sans font-medium" style={{ color: 'inherit' }}>
          Click Frenzy {timeLeft <= 0 ? '— Time\'s up!' : ''}
        </span>
        <span className="text-xs font-sans" style={{ color: '#8c8782' }}>
          {started ? `${score} clicks | ${timeLeft}s` : 'Click to start'}
        </span>
      </div>
      <div
        style={{ width: '264px', height: '264px', position: 'relative', border: '1px solid rgba(128,128,128,0.15)', background: 'rgba(128,128,128,0.05)', margin: '0 auto', cursor: !started ? 'pointer' : 'default' }}
        onClick={() => { if (!started) { setStarted(true); } }}
      >
        {started && timeLeft > 0 && (
          <div
            onClick={(e) => { e.stopPropagation(); handleClick(); }}
            style={{
              position: 'absolute',
              left: `${targetPos.x}%`, top: `${targetPos.y}%`,
              width: '40px', height: '40px', borderRadius: '50%',
              background: '#C9A84C',
              boxShadow: '0 2px 10px rgba(196,162,101,0.3)',
              transform: 'translate(-50%,-50%)',
              cursor: 'pointer',
              transition: 'all .1s',
            }}
          />
        )}
        {!started && (
          <div className="flex items-center justify-center h-full">
            <p className="font-sans text-sm" style={{ color: '#8c8782' }}>Click anywhere to start!</p>
          </div>
        )}
        {timeLeft <= 0 && (
          <div className="flex items-center justify-center h-full flex-col gap-2">
            <p className="font-serif text-2xl font-bold" style={{ color: '#C9A84C' }}>{score}</p>
            <p className="font-sans text-xs" style={{ color: '#8c8782' }}>clicks in 15 seconds</p>
          </div>
        )}
      </div>
    </div>
  );
});

ClickerGame.displayName = 'ClickerGame';
export default ClickerGame;
